/**
 * Supabase connection details.
 *
 * Committed on purpose. Neither value is a secret: the project URL is public,
 * and the publishable key is designed to be used from a browser — it already
 * ships inside the iOS app binary, and Vite inlines it into this bundle in
 * plain text whatever we do. What actually protects the data is RLS, which
 * requires an approved i18n_member row for every table this app touches; an
 * anonymous session sees zero rows.
 *
 * Keeping them here means a deploy needs no dashboard configuration, which
 * matters because a static-assets Worker cannot be given variables at all.
 * An environment variable still wins where one is set, for pointing a local
 * checkout at a different project.
 *
 * The service role key is the opposite of this and must NEVER appear here or
 * behind a VITE_ prefix: it bypasses RLS completely.
 */
const DEFAULT_URL = 'https://ynfpyuwifrvqqvoriaxe.supabase.co';
const DEFAULT_PUBLISHABLE_KEY = 'sb_publishable_Mu2NqvtpbMgxmU2SuFKosw_gTWVK1ox';

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || DEFAULT_URL;
export const SUPABASE_PUBLISHABLE_KEY =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || DEFAULT_PUBLISHABLE_KEY;
